import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getCurrentOrganization } from 'ducks/organizations'
import { useFunnelTracking } from 'hooks/useFunnelTracking'
import { startSessionRecording } from 'utils/mixpanel'
import { useFlags } from 'flags'

import Button from 'components/Shared/Button'
import Icon from 'components/Shared/Icon'
import { GroupedAccordion } from 'components/Shared/Accordion'
import SheetBridgeIcon from './SheetBridgeIcon'

const AddExternalCollectionAccordion = ({ appId, isEnabled }) => {
  const flags = useFlags()
  const isSheetBridgeEnabled = flags.sheetbridge
  const history = useHistory()
  const { trackClickedAddIntegration, trackClickedSheetBridge } =
    useFunnelTracking()
  const currentOrganization = useSelector(getCurrentOrganization)

  const addApiUrl = `/apps/${appId}/data/new-external-collection`
  const sheetBridgeUrl = `/apps/${appId}/data/sheetbridge`

  const handleExternalCollectionClick = () => {
    if (currentOrganization?.id) {
      startSessionRecording()
      trackClickedAddIntegration(currentOrganization.id)
    }
    history.push(addApiUrl)
  }

  const handleSheetBridgeClick = () => {
    if (currentOrganization?.id) {
      startSessionRecording()
      trackClickedSheetBridge(currentOrganization.id).catch(error => {
        console.error('Failed to track SheetBridge click:', error)
      })
    }
    history.push(sheetBridgeUrl)
  }

  return (
    <GroupedAccordion
      className="add-to-database__accordion"
      title={
        <Button component="div" orange listAddButton>
          <Icon type="plus" /> Add Collection
        </Button>
      }
      hideOnly
      hideCarret
      renderChildren={() => (
        <div className="add-to-database__accordion__children">
          <div onClick={handleExternalCollectionClick}>
            <Icon big color="darkerGray" type="add-collection" />
            <span>External Collection</span>
          </div>
          {isEnabled && isSheetBridgeEnabled && (
            <div
              className="sheetbridge-collection-option"
              onClick={handleSheetBridgeClick}
            >
              <SheetBridgeIcon className="bridge-icon-option" variant="gray" />
              <span>SheetBridge</span>
            </div>
          )}
        </div>
      )}
    />
  )
}

export default AddExternalCollectionAccordion
